import React, { ReactNode } from 'react';
import { useGlobalLoaderContext } from '../../contexts/GlobalLoaderContext';
import GlobalLoader from './GlobalLoader';

interface GlobalLoaderWrapperProps {
  children: ReactNode;
}

const GlobalLoaderWrapper: React.FC<GlobalLoaderWrapperProps> = ({ children }) => {
  const { isLoading, message } = useGlobalLoaderContext();

  return (
    <>
      {children}
      {isLoading && <GlobalLoader message={message} />}
    </>
  );
};

export default GlobalLoaderWrapper;
